export const INIT = "INIT";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const OPEN_MODAL = "OPEN_MODAL";
export const PAY = "PAY";
export const SHOW_PANIER = "SHOW_PANIER";
export const UPDATE_QUANTITY = "UPDATE_QUANTITY";